import React from "react"
import { Container } from "react-bootstrap"

export default function SubmitRuleset() {
    return <Container>
        <h1 className={"brand"}>Submit a Ruleset</h1>
        <hr className={"border-bottom border-primary border-4 opacity-100"}></hr>
    </Container>
}